<template>
  <div class='home'>
    <PackageList
      v-show='listView'
      @newPackage='onClickNewFromList'
      @editPackage='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <PackageForm
      v-show='formView'
      :packages='packages'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import PackageList from '@/components/package/PackageList.vue'
import PackageForm from '@/components/package/PackageForm.vue'

export default {
  name: 'Package',
  components: {
    PackageList,
    PackageForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      packages: {
        id: null,
        product_no: null,
        name: null,
        price: null,
        valid_date: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.packages = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const date = new Date().toISOString()
      this.listView = false
      this.formView = true
      this.packages = {
        id: null,
        product_no: null,
        name: null,
        price: null,
        valid_date: date
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.packages = {
        id: null,
        product_no: null,
        name: null,
        price: null,
        valid_date: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getProductList')
  }
}
</script>
